import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { ListMember } from "../../types";

// Every list_members row this person can see: RLS narrows the unfiltered
// result to every row on a List they own (any status), plus their own row
// on a List they don't — exactly enough to answer both "which of my Lists
// are shared" and "which Lists are shared with me" in one round trip, the
// same trick ios/SCHEMA.md documents for the iOS client.
export async function fetchListMembers(): Promise<ListMember[]> {
  const { data, error } = await supabase.from("list_members").select("*");
  if (error) throw error;
  return (data ?? []) as ListMember[];
}

export function useListMembers() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.listMembers,
    queryFn: fetchListMembers,
    enabled: !!user,
  });
}
